import { z } from 'zod';

export const GetCommentsResponse = z.object({
  id: z.number(),
  body: z.string().nullish(),
  episode: z.number().nullish(),
  episodeVersion: z.number().nullish(),
  username: z.string().nullish(),
  userId: z.string().nullish(),
  firebaseId: z.string().nullish(),
  path: z.string().nullish(),
  story: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  bodyLength: z.number().nullish(),
  likesCount: z.number().nullish(),
  repliesCount: z.number().nullish(),
  parentCommentId: z.number().nullish(),
  isUserLikedComment: z.boolean(),
  userAvatar: z.string().nullish(),
  isBlocked: z.boolean().nullish(),
  isHidden: z.boolean().nullish(),
  files: z.array(z.string()).nullish(),
});
